import React from 'react'
import PropTypes from 'prop-types'
import { Box } from 'pcln-design-system'
import PrimaryHeading from './PrimaryHeading'
import SecondaryHeading from './SecondaryHeading'

const HEADER_TYPES = {
  primary: PrimaryHeading,
  secondary: SecondaryHeading
}

const Header = ({ children, ...props }) => (
  <Box data-autobot-element-id='HEADER' textAlign='left' width={1} {...props}>
    {children}
  </Box>
)

Header.Heading = ({ children, name, fallback, type, ...props }) => {
  const Component = HEADER_TYPES[type]
  return (
    <Component name={name} fallback={fallback} {...props}>
      {children}
    </Component>
  )
}

Header.Heading.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.string.isRequired,
  name: PropTypes.string,
  type: PropTypes.string.isRequired
}

Header.propTypes = {
  children: PropTypes.node
}

export default Header
